<div class="ui-message-error" *ngIf="!isControlValid">
    <div class="ui-message-icon"></div>
    <div class="ui-message-content">
        <p aria-live="polite" aria-hidden="false" role="alert" id="{{controlToValiddate}}_Error">{{errorMessage}}</p>
    </div>
</div>
